import { ADMIN_STATE_KEY } from "~/admin";
import { VENDOR_DATA_KEY } from "./reducer";

const _getModuleState = (state) => state[ADMIN_STATE_KEY][VENDOR_DATA_KEY];

export const getVendorEquipmentList = (state) => _getModuleState(state).equipmentList;
export const getTestingLabVendors = (state) => _getModuleState(state).testingLabVendors;
export const getTestPackages = (state) => _getModuleState(state).testPackages;
